module.exports = __webpack_public_path__ + "static/media/team_03.626d9243.jpg";